<template>
  <div class="display-14" v-if="!expand">
    {{ shortTextDisplay }}
    <a class="expand" v-if="!isLongText" @click="showFullText">קרא עוד</a>
  </div>
  <div class="display-14" v-else>
    {{ text }}
    <a class="expand" v-if="!isLongText" @click="hideFullText">הסתר</a>
  </div>
</template>

<script>
import { isNil } from 'lodash'

export default {
  props: {
    text: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      expand: false
    }
  },
  computed: {
    isLongText() {
      return this.text === this.shortTextDisplay
    },
    shortTextDisplay() {
      var shortText = ''
      var rowLength

      if (this.$vuetify.breakpoint.mdAndUp) {
        rowLength = 335
      } else if (this.$vuetify.breakpoint.smOnly) {
        rowLength = 150
      } else {
        rowLength = 90
      }

      if (!isNil(this.text)) {
        if (this.text.length > rowLength) {
          shortText = this.text.substring(0, rowLength) + '...'
        } else {
          shortText = this.text
        }
      }

      return shortText
    }
  },
  methods: {
    showFullText() {
      this.expand = true
    },
    hideFullText() {
      this.expand = false
    }
  },
  created() {
    this.expand = true
  },
  mounted() {
    this.expand = false
  }
}
</script>

<style scoped>
.expand {
  text-decoration: underline !important;
  color: black !important;
}
</style>